
import {
  computed, defineComponent, onBeforeUnmount, PropType, ref,
} from 'vue'
import FormItem from '@/vue/ui/form/FormItem.vue'
import IconCheck from '@/vue/icons/IconCheck.vue'
import { useI18n } from 'vue-i18n'

type selectValue = string | number | boolean

export interface SelectItem {
  value: selectValue
  title: string
}

export default defineComponent({
  name: 'FormSelect',
  props: {
    modelValue: [String, Number, Boolean, Array] as PropType<selectValue | selectValue[]>,
    items: {
      type: Array as PropType<SelectItem[]>,
      required: true,
    },
    label: String as PropType<string>,
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    multiple: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  components: {
    IconCheck,
    FormItem,
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const value = computed<selectValue | selectValue[]>({
      get: () => (props.modelValue === undefined || props.modelValue === null ? '' : props.modelValue),
      set: (v) => emit('update:modelValue', v),
    })
    const currentValue = computed(() => {
      const values = props.items.filter((i: SelectItem) => {
        if (props.multiple) {
          return (value.value as selectValue[]).includes(i.value)
        }
        return value.value === i.value
      }).map((i: SelectItem) => i.title)
      return `${values.length > 1 ? `(${values.length}) ` : ''}${values.length ? values.join(', ') : t('admin.ui.notChecked')}`
    })

    const opened = ref(false)

    const selectItem = (v: selectValue) => {
      if (props.multiple) {
        const val = [...(value.value as selectValue[])]
        const index = val.indexOf(v)
        if (index >= 0) {
          val.splice(index, 1)
        } else {
          val.push(v)
        }
        value.value = val
      } else {
        value.value = v
        opened.value = false
      }
    }

    const itemClass = (v: selectValue) => [
      'ui-form-item__select__item',
      {
        'ui-form-item__select__item--selected': props.multiple ? (value.value as selectValue[]).includes(v) : v === value.value,
      },
    ]

    const closeItems = () => {
      opened.value = false
    }
    document.addEventListener('click', closeItems, { passive: true })
    onBeforeUnmount(() => document.removeEventListener('click', closeItems))

    return {
      value,
      currentValue,
      opened,
      selectItem,
      itemClass,
    }
  },
})
